import { AlertCircle, AlertTriangle, CheckCircle2, Info, X } from 'lucide-react';
import { classNames } from '../../utils/classNames';

const variants = {
  success: { box: 'border-success-100 bg-success-50 text-success-700', icon: CheckCircle2 },
  warning: { box: 'border-warning-100 bg-warning-50 text-warning-700', icon: AlertTriangle },
  danger: { box: 'border-danger-100 bg-danger-50 text-danger-700', icon: AlertCircle },
  info: { box: 'border-info-100 bg-info-50 text-info-700', icon: Info },
};

function Alert({ title, children, variant = 'info', onClose, className }) {
  const { box, icon: Icon } = variants[variant];
  return (
    <div className={classNames('flex gap-3 rounded-card border p-4', box, className)} role="alert">
      <Icon className="mt-0.5 size-5 shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        {title && <p className="text-sm font-semibold">{title}</p>}
        {children && <div className="mt-1 text-sm opacity-90">{children}</div>}
      </div>
      {onClose && (
        <button onClick={onClose} className="rounded p-0.5 opacity-70 hover:opacity-100" aria-label="Cerrar alerta">
          <X className="size-4" />
        </button>
      )}
    </div>
  );
}

export default Alert;
